
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
var redirectURL = require('../redirectURL');

 
const onShowstoppagesIcon = (props) => {
    const handleStoppage = (e) => {
        e.stopPropagation();
       

    
        props.onShowStoppagesData(props)
    };
    const style = {
        enroute_exception: "#cccc",
      
    }
    if (props?.data?.stoppage_alert != undefined && props?.data?.stoppage_alert == 1) {
        style["enroute_exception"] = "#a34518"
    }

    return (
        <div className="map-icon-component">
            {/*<button onClick={handleClick} className="custom-btn label label-success" title="View Timeline"><i className="icofont icofont-tree-alt"></i> Timeline </button>
            &nbsp;| &nbsp;
            */}
 {/* { props.hasUpload !==1 ? (
                <button onClick={handleRouteClick} className="custom-btn label label-success" title="Shipment Legs">
                    <i className="icofont icofont-site-map f20"></i> 
                </button>
            ): (<button onClick={handleRouteClick}  style={{border:"none", backgroundColor:"transparent",
                pointerEvents: props.disabled ? "none" : "auto", 
                opacity: props.disabled ? 0.5 : 1, }}className="custom-btn label label-success" title="Upload POD Inside">
<button className="icon-square" style={{color:"green"}}>
    <i className="icofont icofont-arrow-right" style={{color:"green"}}></i>
</button>        </button>)}        */}
 <span onClick={handleStoppage} title="Stoppages">
                        <i className="icofont icofont-pause f18" style={{ color: style.enroute_exception }}></i>
                    </span>
        </div>
    );
};

export default onShowstoppagesIcon;
